import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import useAuthenticatedData from '../hooks/useAuthenticatedData';
import { type } from '@testing-library/user-event/dist/type';

import SalesBacklogChart from './SalesBacklogChart';

import SalesRevenueGoal from './SalesRevenueGoal';
import RepairsSpendGoal from './RepairsSpendGoal';
import PurchasingSpendGoal from './PurchasingSpendGoal';
import RepairsBacklogChart from './RepairsBacklogChart';
import CombinedSCBacklogChart from './CombinedSCBacklogChart';
import CombinedSCSpendGoal from './CombinedSCSpendGoal';

const SimpleQuad = () => {

  return (
    <div>
      <div className="quadrant-container">
        <SalesBacklogChart />
        <SalesRevenueGoal />
        <CombinedSCBacklogChart />
        <CombinedSCSpendGoal />
      </div>
    </div>
  );
}

export default SimpleQuad;